var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17 15.445c1.19-.693 2-1.968 2-3.445v-1a4 4 0 0 0-8 0v1c0 1.477.81 2.752 2 3.445v.719c-3.449.555-6 2.507-6 4.836v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1c0-2.329-2.551-4.281-6-4.836z"
})));
export default SvgPerson;